<template>
    <div
      class="np-group justify-content-center align-items-center"
      :class="[classes, statusClass]"
      v-if="dateEnd"
    >
      <svg style="scale: 0.8;"><use href="@/assets/images/icons/timer.svg#icon"></use></svg>
      <span class="np-font-s np-lh-s np-nowrap" style="margin-top: 1px;">
        {{ daysToOverall }} {{ $t("UI.task.daysTo") }}
      </span>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      dateStart: {
        type: Number,
        default: 0,
      },
      dateEnd: {
        type: Number,
        default: 0,
      },
      classes: {
        type: String,
        default: 'np-transparent np-borderless',
      },
    },
    computed: {
      daysTo() {
        if (!this.dateEnd) return '--'

        const end = this.dateEnd
        const current = new Date().getTime() / 1000
        const daysTo = parseInt((end - current) / 86400)

        if (end > 0 && current < end) {
          return daysTo
        }

        return 0
      },      
      daysToOverall() {
        if (!this.dateEnd) return '--'

        const end = this.dateEnd
        const current = new Date().getTime() / 1000
        const daysTo = parseInt((end - current) / 86400)

        return daysTo
      },
      // Вычисляемое свойство для определения класса
      statusClass() {
        if (!this.dateEnd || !this.dateStart) return ''
        if (this.daysTo == 0) return 'np-danger'

        const start = this.dateStart
        const end = this.dateEnd
        const current = new Date().getTime() / 1000
        const totalTime = end - start
        const deltaTime = end - current
  
        if (totalTime <= 0) return 'np-danger' // Если время истекло
  
        const halfTime = totalTime / 2
        const quarterTime = totalTime / 4
  
        if (deltaTime > halfTime) {
          return 'np-success' // Осталось больше половины времени
        } else if (deltaTime > quarterTime) {
          return 'np-warning' // Осталось меньше половины, но больше 25%
        } else {
          return 'np-danger'  // Осталось меньше 25%
        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* Ваши стили */
  </style>